import * as ep from "./endpoints";
import api from "@/libs/axios";

export default {
  namespaced: true,
  state: () => ({
    ngoData: {},
    loading: false,
    loadingsetPrograms: false,
    programs: [],
    statistics: [],
    loadingStatistics: false,
    similarNgos: [],
  }),
  getters: {
    ngoData(state) {
      return state.ngoData;
    },
    loading(state) {
      return state.loading;
    },
    programs(state) {
      return state.programs;
    },
    loadingsetPrograms(state) {
      return state.loadingsetPrograms;
    },
    statistics(state) {
      return state.statistics;
    },
    loadingStatistics(state) {
      return state.loadingStatistics;
    },
    similarNgos(state) {
      return state.similarNgos;
    },
  },
  mutations: {
    setNgoData(state, payload) {
      state.ngoData = payload;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setPrograms(state, payload) {
      state.programs = payload;
    },
    setStatistics(state, payload) {
      state.statistics = payload;
    },
    setSimilarNgo(state, payload) {
      state.similarNgos = payload;
    },
  },
  actions: {
    async getNgoData(context, payload) {
      context.commit("setLoading", true);
      await api
        .get(ep.ngo_data(payload.id))
        .then((res) => {
          context.commit("setNgoData", res.data.data);
          context.commit("setLoading", false);
        })
        .catch((err) => {});
    },
    async getPrograms(context, payload) {
      context.state.loadingsetPrograms = true;
      await api
        .get(ep.programs(payload.id))
        .then((res) => {
          context.commit("setPrograms", res.data.data);
          context.state.loadingsetPrograms = false;
        })
        .catch((err) => {});
    },
    async getSimilarNgo({ commit }, id) {
      await api.get(ep.ngo_data(id)).then((res) => {
        commit("setSimilarNgo", res.data.data.similar);
      });
    },
    async getStatistics(context, payload) {
      context.state.loadingStatistics = true;
      await api
        .get(ep.statistics(payload.id))
        .then((res) => {
          context.commit("setStatistics", res.data.data);
          context.state.loadingStatistics = false;
        })
        .catch((err) => {});
    },
  },
};
